const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const createWidgetLoader = require('components-framework/widget/create_widget_loader');
const View = require('./view');
const Model = require('./model');

const widgetFactory = createWidgetFactory({
    name: 'atol_protected',
    viewClass: View,
    modelClass: Model,
    options: {
        ['atol-protected-results-preselected']: {
            hasTooltip: true,
        },
        ['atol-protected-header-tooltip']: {
            hasTooltip: true,
        },
        ['atol-protected-accommodation-details-footer']: {
            hasFooter: true,
            hasLabelInformation: true,
        },
        ['atol-protected-pax-footer-tooltip']: {
            hasTooltip: true,
        },
        ['atol-protected-payment-footer-tooltip']: {
            hasTooltip: true,
        },
    },
});

module.exports.loadAtolWidgets = (atolIds, options = {}) => {
    const atolWidgets = createWidgetLoader(atolIds.reduce((widgetLoader, atolId) => ({
        ...widgetLoader,
        [atolId]: [atolId, widgetFactory, options],
    }), {}));
    Odigeo._.defer(() => atolIds.forEach((atolId) => {
        atolWidgets.remove(atolId);
        atolWidgets.get(atolId);
    }));
};
